import { render } from "./Checkbox.vue?vue&type=template&id=3f4a8d8e"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__